/*
 * Proprietary and confidential | 2026 | SoundTalks NV
 */

const prefix = (type) => `st/notificationSettings/${type}`;

export const SITE_MUTES_LOAD_START = prefix('SITE_MUTES_LOAD_START');
export const SITE_MUTES_LOAD_SUCCESS = prefix('SITE_MUTES_LOAD_SUCCESS');
export const SITE_MUTES_LOAD_FAILED = prefix('SITE_MUTES_LOAD_FAILED');

export const MUTES_LOAD_START = prefix('MUTES_LOAD_START');
export const MUTES_LOAD_SUCCESS = prefix('MUTES_LOAD_SUCCESS');
export const MUTES_LOAD_FAILED = prefix('MUTES_LOAD_FAILED');

export const MUTE_DELETED = prefix('MUTE_DELETED');

export const PREFERENCES_LOAD_START = prefix('PREFERENCES_LOAD_START');
export const PREFERENCES_LOAD_SUCCESS = prefix('PREFERENCES_LOAD_SUCCESS');
export const PREFERENCES_LOAD_FAILED = prefix('PREFERENCES_LOAD_FAILED');
export const PREFERENCE_UPDATED = prefix('PREFERENCE_UPDATED');
